import type { ArenaDef } from "../../sim";

/** Литейня — первая арена: 960 px мира, камера показывает 640. Пол — y = 0 мира. */
export const FOUNDRY: ArenaDef = { id: "foundry", name: "Литейня", left: 64, right: 896, startGap: 270, maxGap: 540 };

export const ARENAS: ReadonlyMap<string, ArenaDef> = new Map([[FOUNDRY.id, FOUNDRY]]);
